import React from "react";

export default function TermsandConditions() {
  return (
    <>
      <div className="max-w-4xl mx-auto my-10 p-8 bg-white shadow-lg rounded-lg">
        <h1 className="text-4xl text-center font-bold text-[#124e66] mb-8">
          Terms and Conditions
        </h1>
        <div className="space-y-6 text-justify leading-7">
          <p className="text-lg">
            <i className="font-semibold">1. Agreement to the Terms:</i>
            <span className="ml-2">
              You accept responsibility for adhering to and being governed by
              these Terms of Service by accessing or using the Professionals
              Spotlight website and services. Please do not use our services if
              you disagree with these terms.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">2. Services Provided:</i>
            <span className="ml-2">
              Professionals Spotlight offers professional biographies and
              business-promoting articles tailored to your specific needs. Our
              services include content creation, SEO optimization, and the
              publication of your biography on platforms such as Executives
              Diary to enhance your visibility and networking opportunities.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">3. Customer Obligations:</i>
            <span className="ml-2">
              For the purpose of creating your biography or promotional article,
              you are in charge of supplying accurate and comprehensive
              material. Requests for changes must be in line with the originally
              agreed-upon scope of the service. Before publishing, manuscripts
              must be reviewed and approved by clients.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">4. Payment and Fees:</i>
            <span className="ml-2">
              All services provided by Professionals Spotlight require upfront
              payment, as detailed on our website. Prices for biographies and
              articles are non-refundable once content creation has begun unless
              otherwise specified. We offer unlimited revisions until client
              satisfaction is achieved.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">5. Ownership of Content:</i>
            <span className="ml-2">
              Upon final payment, ownership of the content we create for you is
              transferred to you. However, Professionals Spotlight reserves the
              right to showcase completed biographies and articles as part of
              our portfolio or case studies unless otherwise agreed upon.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">6. Revisions and Edits:</i>
            <span className="ml-2">
              Professionals Spotlight provides free future edits to your
              content. Edits are based on updated information provided by you
              and must fall within the scope of the originally created content.
              Additional or major revisions may incur an additional fee.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">7. Liability Limitations:</i>
            <span className="ml-2">
              Any indirect, incidental, or consequential losses resulting from
              using or not being able to utilize Professionals Spotlight's
              services are not covered by our liability policy. Furthermore,
              third-party websites or services where your content might be
              shared or published are not under our control.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">8. Termination of Services:</i>
            <span className="ml-2">
              We reserve the right to terminate services to any client if these
              Terms of Service are violated or if any fraudulent activity is
              suspected.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">9. Changes to Terms:</i>
            <span className="ml-2">
              Professionals Spotlight reserves the right to update these Terms
              of Service at any time. Modifications take effect right away after
              they are posted. Acceptance of the updated terms is indicated by
              your continued use of our services after any modifications.
            </span>
          </p>
        </div>
      </div>
    </>
  );
}
